var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeGreenSliderMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 345,
    height: 471,
    viewBox: "0 0 345 471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 345,
    height: 471,
    transform: "translate(0 602)",
    fill: "#ddd"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_67",
    x: -372,
    y: -154.686,
    width: 983.029,
    height: 750.372,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#6f6d71",
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shape-green-slider-mobile",
    transform: "translate(0 -602)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 602)",
    filter: "url(#Rectangle_67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_67-2",
    "data-name": "Rectangle 67",
    d: "M64.933.653,516.63,0,831.962,533.719l-767.029.653Z",
    transform: "translate(-328.93 -38.69)",
    fill: "#086d84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeGreenSliderMobile);
export default __webpack_public_path__ + "static/media/shape-green-slider-mobile.4bed15b52e6261146d0457255abef09f.svg";
export { ForwardRef as ReactComponent };